import styles from './faults_grid.module.scss';
import React from 'react';
import {classNames} from '../../support/classnames.ts';

interface OwnProps {
    children: React.ReactNode;
    disabled?: boolean;
}

export function FaultsGrid({children, disabled}: OwnProps) {
    return (
        <div
            className={classNames(styles.faults_grid, {
                [styles.disabled]: disabled,
            })}
        >
            {children}
        </div>
    );
}
